<template>
	<div>
		<div class="dtable-container table-responsive mt-5">
			<table id="tablaEvaluaciones" class="table table-striped table-bordered" style="width:100%">
				<thead>
					<tr>
						<th>#</th>
						<th>Nombre</th>
						<th>Numero Documento</th>
						<th>Controles</th>
						<th>Recuperativa</th>
						<th>Diagnostica</th>
						<th>Examen</th>
						<th>PromedioFinal</th>
					</tr>
				</thead>
			</table>
		</div>
		<reinicioEvaluacion />
		<!-- <v-client-table :data="tableData" :columns="columns" :options="options">
			<router-link slot="nombre" slot-scope="props" :to="'/infoAlumno/' + props.row.idAlumno" >{{ props.row.nombre }}</router-link>
			<div slot="listadoControles" slot-scope="alumno">
				<span v-if="jsonControl.length == 0">-</span>
				<div v-for="item in jsonControl" :key="item.id">
					<router-link :to="'/evaluacion-alumno/' + item.idEvaluacion + '/' + alumno.row.idAlumno">
						{{ item.nombreEvaluacion }}
					</router-link>
				</div>
			</div>
			<div slot="recuperativa" slot-scope="alumno">
				<span v-if="jsonRecuperativa.length == 0">-</span>
				<div
					v-for="itemRecuperativa in jsonRecuperativa"
					:key="itemRecuperativa.id"
				>
					<router-link :to="'/evaluacion-alumno/' + itemRecuperativa.idEvaluacion + '/' + alumno.row.idAlumno">
						{{ itemRecuperativa.nombreEvaluacion }}</router-link>
				</div>
			</div>
			<div slot="diagnostica" slot-scope="alumno">
				<span v-if="jsonDiagnostico.length == 0">-</span>
				<div
					v-for="itemDiagnostico in jsonDiagnostico"
					:key="itemDiagnostico.id"
				>
					<router-link
						:to="
							'/evaluacion-alumno/' +
								itemDiagnostico.idEvaluacion +
								'/' +
								alumno.row.idAlumno
						"
					>
						{{ itemDiagnostico.nombreEvaluacion }}</router-link
					>
				</div>
			</div>
			<div slot="examen"  slot-scope="props" v-if="parseInt(props.row.promedioFinal) > 0" >
					<div v-for="itemExamen in jsonExamen" :key="itemExamen.id">
						<router-link
							:to="
								'/evaluacion-alumno/' +
									itemExamen.idEvaluacion +
									'/' +
									props.row.idAlumno
							"
						>
							{{ itemExamen.nombreEvaluacion }}</router-link
						>
					</div>
			</div>
			<div v-else slot="examen">
				<span>-</span>
			</div>
			
			<p slot="promedioFinal" slot-scope="props">{{ precise_round(props.row.promedioFinal,1) }}</p>
		</v-client-table> -->
	</div>
</template>
<script>

import { mapActions, mapState } from "vuex";
import reinicioEvaluacion from "../curso/modal/reinicioEvaluacion.vue";
import $ from "jquery";


export default {
	components: {
		reinicioEvaluacion,
	},
	data() {
		return {
			saludo: [{}],
			loadAlumno: false,
		};
	},
	computed: {
		...mapState("alumno", ["jsonAlumno"]),
		...mapState("curso", ["jsonCurso"]),
		...mapState("evaluacion", ["jsonControl"]),
		...mapState("evaluacion", ["jsonExamen"]),
		...mapState("evaluacion", ["jsonDiagnostico"]),
		...mapState("evaluacion", ["jsonRecuperativa"]),
		tableData() {
			if (this.jsonAlumno) {
				return this.jsonAlumno;
			}
			return [];
		},
	},
	methods:{
		...mapActions("alumno", ["addActiveAlumno"]),
		precise_round(num, decimals) {
			if(num == '-'){
				return '-'
			}
			var t = Math.pow(10, decimals);
			return (
				Math.round(
					num * t +
						(decimals > 0 ? 1 : 0) *
							(Math.sign(num) * (10 / Math.pow(100, decimals)))
				) / t
			).toFixed(decimals);
		}
		
	},
	mounted(){
        //listener del icono de la tabla
		$(document).on('click', '.restartIcon',(e)=>{
			this.$root.$emit("bv::show::modal", "modal-reinicioEvaluacion");	
			let idEvaluacion = $(e.currentTarget).data().idevaluacion;
			let idAlumno = $(e.currentTarget).data().idalumno;
			let numeroDocumento = $(e.currentTarget).data().numeroDocumento;
			let nombreApellido = $(e.currentTarget).data().nombreapellido;

			let alumno = {
				idAlumno: idAlumno,
				idEvaluacion: idEvaluacion,
				nombreAlumno: nombreApellido,
				numeroDocumento:numeroDocumento
			};
			this.addActiveAlumno(alumno);
		});

		$('#tablaEvaluaciones').DataTable({
				"bDestroy": true,
				"language": {
					search: 'Buscar: ',
					processing: "Cargando... ",
					searchPlaceholder: 'Buscar',
					lengthMenu:"Mostrar _MENU_ registros",
					info:"Mostrando _START_ a _END_ de _TOTAL_ registros",
					emptyTable: "No hay registros disponibles para el proceso seleccionado",
					infoEmpty: "No hay registros para mostrar",
					infoFiltered:"(Filtrado de _MAX_ registros totales)",
					"paginate": {
						"first":      "Primera",
						"last":       "Última",
						"next":       "Siguiente",
						"previous":   "Anterior"
					},	
			},
			"processing": true,
			"serverSide": true,
			"ajax": {
				"type":"POST",
				"url": this.axios.defaults.baseURL+"api/getInfoCursoByIdDatatable",
				'data' : { 'idCurso' : this.jsonCurso.idCurso },
				"dataType": "JSON",
				"headers": {
					"Authorization": this.axios.defaults.headers.Authorization
				},
			},
				columns: [
					{ data: 'idAlumno' },//ok 0
					{ data: 'nombre' },//ok 1
					{ data: 'numeroDocumento' },//ok 2
					{ data: 'controles' },//ok 3
					{ data: 'recuperativa' },//ok 4
					{ data: 'diagnostica' },//ok 5
					{ data: 'examen' },//ok 6
					{ data: 'promedioFinal' },//ok 7
				],
				columnDefs: [
					{
						"targets": 1,
						"data": "nombre",
						"width": "20%",
						"bSortable": true,
						"render": function ( data, type, row, meta ) {
							return `<a href="/infoAlumno/${row.idAlumno}">${data}</a>`;
						}
					},
					{
						"targets": 3,
						"data": "controles",
						"width": "20%",
						"bSortable": false,
						"render": ( data, type, row, meta )=>{
							if(this.jsonControl.length == 0){
								return "-";
							}else{
								let htmlInicial = ``;
								this.jsonControl.forEach(element => {
									htmlInicial = htmlInicial + `<a href="/evaluacion-alumno/${element.idEvaluacion}/${row.idAlumno}">${element.nombreEvaluacion}</a>
									 <button class="buttonReiniciar restartIcon" data-nombreapellido="${row.nombre}" data-numerodocumento="${row.numeroDocumento}" data-idevaluacion="${element.idEvaluacion}" data-idalumno="${row.idAlumno}"></button><br>`;
									// htmlInicial = htmlInicial + `<a href="/evaluacion-alumno/${element.idEvaluacion}/${row.idAlumno}">${element.nombreEvaluacion}</a> <img src="https://cdn-icons-png.flaticon.com/512/25/25429.png" style="width: 15px;"><br>`;
								});
								return htmlInicial;
							}
						}
					},
					{
						"targets": 4,
						"data": "recuperativa",
						"width": "15%",
						"bSortable": false,
						"render": ( data, type, row, meta )=>{
							if(this.jsonRecuperativa.length == 0){
								return "-";
							}else{
								let htmlInicial = ``;
								this.jsonRecuperativa.forEach(element => {
									htmlInicial = htmlInicial + `<a href="/evaluacion-alumno/${element.idEvaluacion}/${row.idAlumno}">${element.nombreEvaluacion}</a> 
									<button class="buttonReiniciar restartIcon" data-nombreapellido="${row.nombre}" data-numerodocumento="${row.numeroDocumento}" data-idevaluacion="${element.idEvaluacion}" data-idalumno="${row.idAlumno}"></button><br>`;
								});
								return htmlInicial;
							}
						}
					},
					{
						"targets": 5,
						"data": "diagnostica",
						"width": "15%",
						"bSortable": false,
						"render": ( data, type, row, meta )=>{
							if(this.jsonDiagnostico.length == 0){
								return "-";
							}else{
								let htmlInicial = ``;
								this.jsonDiagnostico.forEach(element => {
									htmlInicial = htmlInicial + `<a href="/evaluacion-alumno/${element.idEvaluacion}/${row.idAlumno}">${element.nombreEvaluacion}</a> 
									<button class="buttonReiniciar restartIcon" data-nombreapellido="${row.nombre}" data-numerodocumento="${row.numeroDocumento}" data-idevaluacion="${element.idEvaluacion}" data-idalumno="${row.idAlumno}"></button><br>`;
								});
								return htmlInicial;
							}
						}
					},
					{
						"targets": 6,
						"data": "examen",
						"width": "25%",
						"bSortable": false,
						"render": ( data, type, row, meta )=>{
							if(this.jsonExamen.length == 0){
								return "-";
							}else{
								let htmlInicial = ``;
								this.jsonExamen.forEach(element => {
									htmlInicial = htmlInicial + `<a href="/evaluacion-alumno/${element.idEvaluacion}/${row.idAlumno}">${element.nombreEvaluacion}</a> 
									<button class="buttonReiniciar restartIcon" data-nombreapellido="${row.nombre}" data-numerodocumento="${row.numeroDocumento}" data-idevaluacion="${element.idEvaluacion}" data-idalumno="${row.idAlumno}"></button><br>`;
								});
								return htmlInicial;
							}
						}
					},
					{
						"targets": 7,
						"data": "promedioFinal",
						"width": "5%",
						"bSortable": true,
						"render": function ( data, type, row, meta ) {
							return data < 4 ? `<span style="color:red;">${data}</span>` : `<span style="color:blue;">${data}</span>` ;
						}
					},
				]
	    });
	}
};
</script>
<style>
 .btnCertificado{
	color: #007bff;
    border-color: #007bff;
    display: inline-block;
    font-weight: 400;
    text-align: center;
    vertical-align: middle;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    background-color: transparent;
    border: 1px solid #007bff;
 }
 td{
	 text-align: center;
	 vertical-align: middle;
 }
 .buttonReiniciar{
	/* color: #fff;
    background-color: #007bff;
    border-color: #007bff;
	border-radius: 20px;
	width: 23px;
    height: 23px;
	font-size: 8px !important; */
    /* color: #fff; */
    /* background-color: #007bff;
    border-color: #007bff; */
    background-image: url("https://static.vgroup.cl/2022/iconos/refresh%20%281%29.png");
    background-repeat: no-repeat;
    background-size: contain;
    border-radius: 20px;
    width: 23px;
    height: 23px;
	border-color: transparent;

 }
</style>